export const getMemedURL = (api = false) => {
  return "memed.com.br";
};
